import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Forms'
import Icon from '@/components/Icon'

import { Icon as AntdIcon } from 'antd'

let PersistenceIndicator = ({ version, savingVersion, savedVersion, errorVersion, uid, persistChanges, errorMessage }) => {
  const [error, setError] = useState({ isHidden: false, message: null })
  let icon = ''
  let color = ''

  if (version > savedVersion) {
    if (errorVersion >= savingVersion) {
      color = 'red'
      icon = 'loader bx-tada'
      if (!error.isVisible && error.message === null) {
        setError({ ...error, message: errorMessage || 'Failed to save changes' })
      }
    } else {
      if (version > savingVersion) { // there are newer changes than those we're currently saving
        // text = 'Common.Saving' // 'Common.PendingChanges' // from UX perspective, it is enough to show saving msg
        color = errorVersion >= savingVersion ? 'danger' : 'orange'
      } else { // we are saving latest changes
        // text = 'Common.Saving'
        color = 'green'
      }
      icon = 'loader bx-spin'
    }
  } else { // saved
    // text = 'Common.Saved'
    icon = 'bx-check'
    color = 'green'
    if (error.message !== null) {
      setError({ ...error, message: null })
    }
  }

  function handleClick () {
    if (color === 'red') {
      persistChanges(uid)
    }
  }

  const ErrorHiderToggler = () => {
    setError({ ...error, isHidden: !error.isHidden })
  }

  function renderErrorMessage () {
    return (
      <div className={error.isHidden ? 'save-error-message is-hidden' : 'save-error-message'}>
        <div className='save-error-message__inner'>
          <span className='text'>{error.message}</span>
          {error.isHidden ? <AntdIcon onClick={() => ErrorHiderToggler()} type='question-circle' /> : <AntdIcon onClick={() => ErrorHiderToggler()} type='close' />}
        </div>
      </div>
    )
  }

  return <React.Fragment>
    <span className={color} onClick={handleClick}>
      <Icon name={icon} />
    </span>
    {error.message && renderErrorMessage()}
  </React.Fragment>
}

function mapStateToProps (state, ownProps) {
  const { uid } = ownProps
  const item = state.forms.getIn(['data', uid])
  const version = (item && item.get('version')) || 0
  const savingVersion = (item && item.get('savingVersion')) || 0
  const savedVersion = (item && item.get('savedVersion')) || 0
  const errorVersion = (item && item.get('errorVersion')) || -1
  const errorMessage = (item && item.get('errorMessage'))
  return {
    uid, version, savingVersion, savedVersion, errorVersion, errorMessage
  }
}

const mapDispatchToProps = {
  persistChanges: actionCreators.persistChanges
}

PersistenceIndicator = connect(mapStateToProps, mapDispatchToProps)(PersistenceIndicator)

export {
  PersistenceIndicator
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/persistenceIndicator.js